import { Component, HostListener } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { UserPhotosComponent } from '../user-photos/user-photos.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlus, faUpload, faBan, faPencil, faTrashCan, faBackspace, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { UploadPhotosComponent } from "../upload-photos/upload-photos.component";
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { SnackbarService } from '../services/snackbar.service';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-photos',
  standalone: true,
  imports: [MatButtonModule, MatCheckboxModule, MatInputModule, MatFormFieldModule, MatTabsModule, UserPhotosComponent, FontAwesomeModule, UploadPhotosComponent, CommonModule, ReactiveFormsModule, MatProgressSpinnerModule],
  templateUrl: './view-photos.component.html',
  styleUrl: './view-photos.component.css'
})
export class ViewPhotosComponent {

  baseUrl: string = 'http://localhost:4200';
  formGroup: FormGroup;
  faplus = faPlus
  faUpload = faUpload
  faBan = faBan
  is_open = false;
  faPencil = faPencil;
  faDeleteLeft = faTrashCan;
  album_Name1 = ''
  backgroundStyle = `#67b7ff no-repeat 50% 50% / 50% 50% url(${this.baseUrl}/assets/image_gallery.svg)`;
  is_valid = false;
  make_private = false;
  fa_back = faArrowLeft;
  is_myProfile: boolean = false;
  userData: any = '';
  loader: boolean = false;
  showText: boolean = true;
  profileComplete!: boolean;

  constructor(private router:Router,private fb: FormBuilder, private snackbarService: SnackbarService, public apiservices: ApiServicesService, private userdetails: UserDetailsService) {
    this.formGroup = this.fb.group({
      album_Name1: ['', Validators.required],
      make_private: [false]
    });
  }

  isOpen() {
    this.is_open = true;
    this.is_delete = false;
    this.is_update = false; ``
    this.album_Name1 = ''
  }

  isClose() {
    this.is_open = false;
    this.is_delete = false;
    setTimeout(() => {
      this.album_Name1 = '';
      this.formGroup.reset();
      this.make_private = false;
      this.is_valid = false;
    }, 500);
  }

  ngOnInit() {
    this.userdetails.userdetails$.subscribe((userData) => {
      this.userData = userData;
      if (userData && userData.user) {
        this.is_myProfile = this.apiservices.checkProfile(this.userData.user.username);
      }
    });

    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiservices.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        // console.log(decryptedData, 'decryptedData')
        this.profileComplete = decryptedData.user.profileCompleteness == 1 ? true : false;
      }
    }

    
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.textLabel === 'Albums') {
      this.getAlbums();
    }
    else{
      // this.back_album();
      this.album_id = '';
      this.album_imgs = false;
      // console.log('111111111111');

    }
  }

  getAlbums() {
    this.isLoading = true;
    this.apiservices.getAllalbum(this.userData.user._id, this.currentPage, this.limit).subscribe({
      next: (responce: any) => {
        if (this.currentPage == 1) {
          this.albums = responce.albums || [];
        } else {
          this.albums = [...this.albums, ...(responce.albums || [])];
        }
        this.totalPages = responce.pagination?.totalPages;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  navigate(){
    this.router.navigate(["/my-profile", this.userData.user.username, 'edit_form']);
  }

  @HostListener('window:scroll', ["$event"])
  onScroll(): void {
    if (
      this.currentPage < this.totalPages &&
      !this.isLoading
    ) {
      this.currentPage++;
      this.getAlbums();
    }
  }

  currentPage = 1;
  totalPages = 1;
  isLoading: boolean = false;
  limit: any = 6;
  albums: any[] = [];
  edit_index!: number;
  delete_index!: number;
  is_update: boolean = false;
  is_delete: boolean = false;
  album_imgs: boolean = false;
  album_name = '';
  album_id: any = '';

  album_in(album: any) {
    this.album_name = album.name;
    this.album_imgs = true;
    this.album_id = album._id;
  }

  back_album() {
    this.album_imgs = false;
    this.getAlbums();
  }

  addAlbum() {
    const albumName = this.formGroup.get('album_Name1')?.value;
    const isPrivate = this.formGroup.get('make_private')?.value || false;
    if (albumName == '' || albumName == null) {
      this.is_valid = true;
    } else {
      this.is_valid = false;
      this.showText = false;
      var data = { name: albumName, isPrivate: isPrivate };
      this.apiservices.createAlbum(data).subscribe({
        next: (responce: any) => {
          if(responce.status==200){
          this.getAlbums();
          this.showText = true;
          this.is_open = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: 'Album Added successfully',
              className: 'success',
            }
          );
          setTimeout(() => {
            this.album_Name1 = '';
            this.formGroup.reset();
            this.make_private = false;
            this.is_valid = false;
          }, 500);
        }else{
          this.showText = true;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: responce.message,
              className: 'failed',
            }
          );
          this.formGroup.reset();
        }
        },
        error: (err) => {
          this.showText = true;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    }
  }

  deleteAlbum(album: any): void {
    this.is_update = false;
    this.is_delete = true;
    this.album_id = album._id;
  }

  confirmDelete(album_id: any) {
    this.showText = false;
    this.apiservices.deleteAlbum(album_id).subscribe({
      next: (response: any) => {
        this.showText = true;
        this.getAlbums();
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: response.message,
            className: 'success',
          }
        );
        this.is_delete = false;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
      }
    });

  }

  editAlbum(album: any): void {
    this.is_open = true;
    this.formGroup.patchValue({
      album_Name1: album.name,
      make_private: album.isPrivate,
    })
    this.is_update = true;
    this.album_id = album._id;
  }

  updateAlbum() {
    const albumName = this.formGroup.get('album_Name1')?.value;
    const isPrivate = this.formGroup.get('make_private')?.value || false;
    if (albumName == '' || albumName == null) {
      this.is_valid = true;
    } else {
      this.is_valid = false;
      this.showText = false;
      var data = { name: albumName, isPrivate: isPrivate, albumId: this.album_id };
      this.apiservices.EditAlbum(data, this.album_id).subscribe({
        next: (response: any) => {
          this.currentPage=1;
          this.is_open = false;
          this.showText = true;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
          this.getAlbums();
          setTimeout(() => {
            this.album_Name1 = '';
            this.formGroup.reset();
            this.make_private = false;
            this.is_valid = false;
          }, 500);
        },
        error: (err) => {
          this.showText = true;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    }
  }

  onEnterPress(event: Event) {
    event.preventDefault();
    if (this.is_update) {
      this.updateAlbum();
    } else {
      this.addAlbum();
    }
  }
}
